import { useMemo } from 'react';
import { useCompany } from '../components/contexts/CompanyContextManager';
import getRelativeLuminance from './getRelativeLuminance';

const useCompanyColorLuminance = () => {
    const company = useCompany(true);

    return useMemo(() => {
        const companyColor = company?.color ? `#${company.color}` : undefined;

        return getRelativeLuminance(companyColor) ?? 0;
    }, [company?.color]);
};

export default useCompanyColorLuminance;
